module.exports = __webpack_public_path__ + "static/media/my1.173a4cc0.svg";